//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CEF',
  data() {
    return {
      form: {
        sv: '',
        edv: '',
      },
      hasScore: false,
      disabled: false,
      res: '...',
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res = form.sv / form.edv
        self.res = res.toFixed(0)

        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CEF.vue